export const shouldNotForwardProps = (propNames: string[]) => ({
  shouldForwardProp: (propName: string) => !propNames.includes(propName),
});
